var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"个人中心","visible":_vm.visible,"width":"400px"},on:{"close":_vm.handleClose}},[_c('div',[_c('p',[_vm._v("用户名："+_vm._s(_vm.userInfo.username))]),_c('p',[_vm._v("邮箱："+_vm._s(_vm.userInfo.email))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }